import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/MuseumsTable.vue"),
          meta: { title: "Список музеев / площадок", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create/:cityId",
          component: () => import("@/views/forms/MuseumsForm.vue"),
          meta: { title: "Создать музей / площадку", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id/:cityId",
          component: () => import("@/views/forms/MuseumsForm.vue"),
          meta: {
            title: "Редактировать музей / площадку",
            activeMenuParent: true,
          },
          hidden: true,
        },
      ],
    },
  ];
};
